export const ETH_ADDRESS_REGEX = /^0x[a-fA-F0-9]{40}$/;

export const isValidEthAddress = (address) => {
    return typeof address === 'string' && ETH_ADDRESS_REGEX.test(address.trim());
};
